import { FC } from 'react';

import { ic_stim_home, ic_stim_home_active } from '.';

const StimHomeMenuIcon: FC<{ width?: number; primary?: boolean }> = ({ width = 24, primary }) => {
  if (primary) {
    return <img src={ic_stim_home_active} width={width} alt="" />;
  }
  return <img src={ic_stim_home} width={width} alt="" />;
};

export default StimHomeMenuIcon;
